"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TimeMe = require("timeme.js");
var page_lifecycle_1 = require("page-lifecycle");
var EventLogger = (function () {
    function EventLogger(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.initialize, initialize = _c === void 0 ? true : _c, _d = _b.debug, debug = _d === void 0 ? false : _d;
        this.addEventListeners = function (element, events) {
            Object.entries(events).forEach(function (_a) {
                var event = _a[0], logger = _a[1];
                element.addEventListener(event, logger);
            });
        };
        this.blurEvent = function (event) {
            var blurEvent = _this.getUniversalEventDetails(event);
            _this.logEvent(blurEvent);
        };
        this.changeEvent = function (event) {
            var changeEvent = _this.getUniversalEventDetails(event);
            _this.logEvent(changeEvent);
        };
        this.clickEvent = function (event) {
            var clickEvent = _this.getUniversalEventDetails(event);
            _this.logEvent(clickEvent);
        };
        this.focusEvent = function (event) {
            var focusEvent = _this.getUniversalEventDetails(event);
            _this.logEvent(focusEvent);
        };
        this.inputEvent = function (event) {
            var inputEvent = _this.getUniversalEventDetails(event);
            _this.logEvent(inputEvent);
        };
        this.keyEvent = function (event) {
            var keyEvent = _this.getUniversalEventDetails(event);
            var key = event.key;
            if (key && key.length === 1)
                keyEvent.uniCode = key.charCodeAt(0);
            _this.logEvent(keyEvent);
        };
        this.loadEvent = function (event) {
            _this.resetTimers(window.location.href);
            var loadEvent = _this.getUniversalEventDetails(event);
            _this.logEvent(loadEvent);
        };
        this.lifecycleEvent = function (event) {
            var state = event.newState;
            var origEvent = event.originalEvent;
            var lifecycleEvent = _this.getUniversalEventDetails(origEvent);
            lifecycleEvent.eventType = "page-" + state;
            _this.logEvent(lifecycleEvent);
        };
        this.pasteEvent = function (event) {
            var _a;
            var pasteEvent = _this.getUniversalEventDetails(event);
            pasteEvent.targetValue = ((_a = event.clipboardData) === null || _a === void 0 ? void 0 : _a.getData('text')) || null;
            _this.logEvent(pasteEvent);
        };
        this.removeEventListeners = function (element, events) {
            Object.entries(events).forEach(function (_a) {
                var event = _a[0], logger = _a[1];
                element.removeEventListener(event, logger);
            });
        };
        this.touchEvent = function (event) {
            var touchEvent = _this.getUniversalEventDetails(event);
            if (event.type === 'touchstart') {
                touchEvent.coordX = Math.round(event.targetTouches[0].pageX);
                touchEvent.coordY = Math.round(event.targetTouches[0].pageY);
            }
            _this.logEvent(touchEvent);
        };
        this.vuetifyEvent = function (event, data, options) {
            if (options === void 0) { options = { anonymize: false }; }
            var eventData = event;
            eventData.anonymize = options.anonymize;
            var changeEvent = _this.getVuetifyEventDetails(eventData, data);
            _this.logEvent(changeEvent);
        };
        this.anonymize = false;
        this.currentPage = '';
        this.debug = debug;
        this.hashId = '';
        this.pageLoadTime = Date.now();
        this.url = 'https://europe-west1-application-event-capture.cloudfunctions.net/capture_events';
        this.useSendDataFallback = false;
        if (initialize) {
            TimeMe.initialize({
                currentPageName: window.location.href,
                idleTimeoutInSeconds: 5,
            });
            this.initializeEventListeners();
        }
    }
    EventLogger.prototype.anonymizeData = function (eventData) {
        if (!this.anonymize)
            return eventData;
        if (eventData.targetValue) {
            eventData.targetValue = String(eventData.targetValue)
                .replace(/\D/g, 'X')
                .replace(/\d/g, '0');
        }
        eventData.key = null;
        eventData.keyCode = null;
        eventData.physicalKey = null;
        eventData.uniCode = null;
        return eventData;
    };
    EventLogger.prototype.gaClientId = function () {
        var gaClientId = null;
        try {
            if (window.ga && typeof window.ga.getAll === 'function') {
                var tracker = window.ga.getAll()[0];
                gaClientId = tracker.get('clientId');
            }
        }
        catch (error) {
            console.error('Error in EventLogger.gaClientId', error);
        }
        return gaClientId;
    };
    EventLogger.prototype.getTimeStamp = function () {
        return new Date().toISOString();
    };
    EventLogger.prototype.getTotalTimeSinceStart = function () {
        return TimeMe.getTimeOnAllPagesInSeconds()
            .reduce(function (total, page) { return total + page.timeOnPage * 1000; }, 0);
    };
    EventLogger.prototype.getVuetifyEventDetails = function (event, additionalData) {
        var eventData = this.getUniversalEventDetails(event);
        if (additionalData) {
            eventData.targetId = additionalData === null || additionalData === void 0 ? void 0 : additionalData.targetId;
            eventData.targetName = additionalData === null || additionalData === void 0 ? void 0 : additionalData.name;
            eventData.targetNode = additionalData === null || additionalData === void 0 ? void 0 : additionalData.nodeName;
            eventData.targetType = additionalData === null || additionalData === void 0 ? void 0 : additionalData.type;
            eventData.targetValue = additionalData === null || additionalData === void 0 ? void 0 : additionalData.value;
        }
        return eventData;
    };
    EventLogger.prototype.getUniversalEventDetails = function (event) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var eventData = {
            altKey: (event === null || event === void 0 ? void 0 : event.altKey) || null,
            checked: ((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.type) === 'checkbox' ? (_b = event === null || event === void 0 ? void 0 : event.target) === null || _b === void 0 ? void 0 : _b.checked : null,
            coordX: (event === null || event === void 0 ? void 0 : event.pageX) || null,
            coordY: (event === null || event === void 0 ? void 0 : event.pageY) || null,
            ctrlKey: (event === null || event === void 0 ? void 0 : event.ctrlKey) || null,
            currentPage: this.currentPage || null,
            eventType: (event === null || event === void 0 ? void 0 : event.type) || null,
            gaClientId: this.gaClientId(),
            hashId: this.hashId || null,
            key: (event === null || event === void 0 ? void 0 : event.key) || null,
            keyCode: (event === null || event === void 0 ? void 0 : event.keyCode) || null,
            metaKey: (event === null || event === void 0 ? void 0 : event.metaKey) || null,
            pageActiveTime: TimeMe.getTimeOnCurrentPageInSeconds() * 1000,
            path: window.location.pathname,
            physicalKey: (event === null || event === void 0 ? void 0 : event.code) || null,
            shiftKey: (event === null || event === void 0 ? void 0 : event.shiftKey) || null,
            targetId: ((_c = event === null || event === void 0 ? void 0 : event.target) === null || _c === void 0 ? void 0 : _c.id) || null,
            targetName: ((_d = event === null || event === void 0 ? void 0 : event.target) === null || _d === void 0 ? void 0 : _d.name) || null,
            targetNode: ((_e = event === null || event === void 0 ? void 0 : event.target) === null || _e === void 0 ? void 0 : _e.nodeName) || null,
            targetType: ((_f = event === null || event === void 0 ? void 0 : event.target) === null || _f === void 0 ? void 0 : _f.type) || null,
            targetValue: ((_h = (_g = event === null || event === void 0 ? void 0 : event.target) === null || _g === void 0 ? void 0 : _g.dataset) === null || _h === void 0 ? void 0 : _h.eventValue) || ((_j = event === null || event === void 0 ? void 0 : event.target) === null || _j === void 0 ? void 0 : _j.value) || null,
            timeSinceLoad: (Date.now() - this.pageLoadTime),
            timeStamp: this.getTimeStamp(),
            totalTimeSinceStart: this.getTotalTimeSinceStart(),
            uniCode: (event === null || event === void 0 ? void 0 : event.uniCode) || null,
            url: window.location.href,
            userAgentString: window.navigator.userAgent || null
        };
        this.anonymize = !!((_l = (_k = event === null || event === void 0 ? void 0 : event.target) === null || _k === void 0 ? void 0 : _k.dataset) === null || _l === void 0 ? void 0 : _l.anonymize) || !!event.anonymize;
        return eventData;
    };
    EventLogger.prototype.handlePageChange = function (_a) {
        var currentPage = _a.currentPage, hashId = _a.hashId;
        this.currentPage = currentPage;
        this.hashId = hashId;
        this.resetTimers(currentPage);
    };
    EventLogger.prototype.initializeEventListeners = function () {
        window.onload = this.loadEvent;
        document.addEventListener('touchstart', this.touchEvent);
        document.addEventListener('touchend', this.touchEvent);
        page_lifecycle_1.default.addEventListener('statechange', this.lifecycleEvent);
    };
    EventLogger.prototype.logEvent = function (eventData) {
        if (!this.validateData(eventData))
            return;
        this.anonymizeData(eventData);
        if (this.debug) {
            console.log('%cEventLogger', 'color: green', eventData.eventType, eventData);
        }
        var jsonData = JSON.stringify(eventData);
        if (this.useSendDataFallback) {
            this.sendDataFallback(jsonData);
            return;
        }
        this.sendData(jsonData);
    };
    EventLogger.prototype.resetTimers = function (currentPage) {
        this.pageLoadTime = Date.now();
        TimeMe.stopTimer();
        TimeMe.setCurrentPageName(currentPage);
        TimeMe.startTimer();
    };
    EventLogger.prototype.sendData = function (body) {
        try {
            if (process.env.NODE_ENV === 'production') {
                var headers = { type: 'application/json' };
                var blob = new Blob([body], headers);
                navigator.sendBeacon(this.url, blob);
            }
        }
        catch (error) {
            this.useSendDataFallback = true;
            this.sendDataFallback(body);
        }
    };
    EventLogger.prototype.sendDataFallback = function (body) {
        try {
            window.fetch(this.url, {
                method: 'post',
                keepalive: true,
                headers: {
                    Accept: 'application/json',
                },
                body: body,
            });
        }
        catch (error) {
            console.error('Send data failed');
        }
    };
    EventLogger.prototype.validateData = function (eventData) {
        if (process.env.NODE_ENV === 'development')
            return true;
        return !!eventData.gaClientId && !!eventData.timeStamp;
    };
    return EventLogger;
}());
exports.default = EventLogger;
